import React from 'react';
import { ABLE_COLORS } from '../../constants';

/**
 * TaskCandidates - Disambiguation UI for multiple task matches
 * Shows clickable options when Mabel finds multiple tasks matching user input
 */
export default function TaskCandidates({ candidates, onSelect }) {
  if (!candidates || candidates.length === 0) return null;

  return (
    <div style={{
      padding: '12px',
      background: ABLE_COLORS.bg,
      borderRadius: '12px',
      border: `2px solid ${ABLE_COLORS.secondary}`
    }}>
      <div style={{
        fontSize: '12px',
        color: '#666',
        marginBottom: '8px'
      }}>
        Click to select:
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
      }}>
        {candidates.map((task, idx) => (
          <button
            key={task.id}
            onClick={() => onSelect(task)}
            style={{
              padding: '10px 12px',
              background: 'white',
              border: `1px solid ${ABLE_COLORS.secondary}`,
              borderRadius: '8px',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = ABLE_COLORS.bg;
              e.currentTarget.style.borderColor = ABLE_COLORS.primary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.borderColor = ABLE_COLORS.secondary;
            }}
          >
            <span style={{ fontWeight: '500' }}>
              {idx + 1}. {task.title}
            </span>
            <span style={{
              fontSize: '12px',
              color: '#888',
              background: ABLE_COLORS.bg,
              padding: '2px 8px',
              borderRadius: '4px'
            }}>
              {task.priority}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
